import Phaser from "phaser";

const eventDispatcher = new Phaser.Events.EventEmitter();

export { eventDispatcher };
